<template>
  <div class="stickers-tools">
    <StickersToolsTabs :artwork="props.artwork">
      <template v-slot="{ tab }">
        <!-- <StickersToolsShape v-if="tab === 'shape'" :artwork="props.artwork" /> -->
        <StickersToolsBackground v-if="tab === 'background'" :artwork="props.artwork" />
        <StickersToolsBorder v-else-if="tab === 'border'" :artwork="props.artwork" />
      </template>
    </StickersToolsTabs>
  </div>
</template>

<script setup>
import StickersToolsTabs from "./StickersToolsTabs.vue";
// import StickersToolsShape from "./StickersToolsShape";
import StickersToolsBackground from "./StickersToolsBackground.vue";
import StickersToolsBorder from "./StickersToolsBorder.vue";

const props = defineProps({
  artwork: [Object, null]
});
</script>

<style lang="scss">
.stickers-tools {
}
</style>
